<script lang="ts">
  export let currentPage;
  export let data;
</script>

<div class="slider-first-slide-container p-4 p-sm-5">
  <h6 class="title">
    {@html data?.heading ?? ""}
  </h6>
  <h1 class="title is-4">
    {@html data?.subText ?? ""}
  </h1>
  <a
    on:click={() => {
      currentPage = "midSlides";
    }}
    class="button is-line is-white is-right"
    target="_blank"
  >
    {data?.buttonText ?? ""}
  </a>
</div>

<style>
  .slider-first-slide-container {
    width: 100%;
    height: 100%;
    display: grid;
    grid-auto-flow: row;
    justify-items: center;
    align-content: center;
    text-align: center;
    color: white;
  }
  .slider-first-slide-container h6.title {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 17px;
  }
  .slider-first-slide-container h1 {
    margin-bottom: 37px;
  }
</style>
